var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialogCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.07985 0.185272C0.832816 -0.0617574 0.432302 -0.0617574 0.185272 0.185272C-0.0617574 0.432302 -0.0617574 0.832816 0.185272 1.07985L5.10547 6.00004L0.185361 10.9202C-0.0616682 11.1672 -0.0616685 11.5677 0.185361 11.8147C0.432391 12.0618 0.832905 12.0618 1.07993 11.8147L6.00004 6.89462L10.9202 11.8147C11.1672 12.0618 11.5677 12.0618 11.8147 11.8147C12.0618 11.5677 12.0618 11.1672 11.8147 10.9202L6.89462 6.00004L11.8148 1.07985C12.0618 0.832816 12.0618 0.432302 11.8148 0.185272C11.5678 -0.0617574 11.1673 -0.0617574 10.9202 0.185272L6.00004 5.10547L1.07985 0.185272Z",
    fill: "#999CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogCancel);
export default __webpack_public_path__ + "static/media/dialog-cancel.4de4780c8eb2f6fbe1535cebf5f3e034.svg";
export { ForwardRef as ReactComponent };